export const USER_ACTION_TYPES = {
  SET_ACCESS_TOKEN: "user/SET_ACCESS_TOKEN",
  DELETE_ACCESS_TOKEN: "user/DELETE_ACCESS_TOKEN",
  SET_IS_LOGGED_IN: "user/SET_IS_LOGGED_IN",
  SET_DAY: "user/SET_DAY",
  SET_LAST_OPENED_DATE: "user/SET_LAST_OPENED_DATE",
  SET_USER_DETAILS: "user/SET_USER_DETAILS",
  SET_STAFF_ACCESS: "user/SET_STAFF_ACCESS",
};
